import { render, staticRenderFns } from "./TypeActivity.vue?vue&type=template&id=030844bb&"
import script from "./TypeActivity.vue?vue&type=script&lang=js&"
export * from "./TypeActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports